var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceFailure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.925,
    viewBox: "0 0 16 15.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M43.493-863.7,31.869-875.324H42.5a1.447,1.447,0,0,1,1.061.441A1.447,1.447,0,0,1,44-873.822v9.014a1.476,1.476,0,0,1-.122.61A1.428,1.428,0,0,1,43.493-863.7ZM29.859-875.193v2.1L28-874.948,29.052-876l14.873,14.873-1.052,1.052-3.23-3.23h-.15v1.5H33.484v-1.5h-3a1.447,1.447,0,0,1-1.061-.441,1.447,1.447,0,0,1-.441-1.061v-9.014a1.219,1.219,0,0,1,.441-1.033Z",
    transform: "translate(-28 876)",
    fill: "#f01445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceFailure);
export default __webpack_public_path__ + "static/media/device_failure.89200378bb2fa6e404e24d1b608a13da.svg";
export { ForwardRef as ReactComponent };